import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, SearchFormaDePagoRequest, SaveFormaDePagoDto, FormaDePago } from "../model/index";
import { SharedFunctions } from '../shared.functions';

@Injectable({
  providedIn: 'root'
})
export class FormaDePagoService extends CrudService<FormaDePago, number, SaveFormaDePagoDto, SearchFormaDePagoRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'formapago', sharedFunctions);
  }
  
}